import {Logo} from '@benchling/nucleus-ui';
import React from 'react';

import {ACCOUNT_TYPE_TO_LOGO, AccountType} from 'notebook/tfi/TFIConstants';

interface Props {
  accountType: AccountType;
  className?: string;
}

export default function TFIAccountIcon({accountType, className}: Props): JSX.Element {
  const name = ACCOUNT_TYPE_TO_LOGO[accountType];
  return <Logo className={className} name={name} />;
}
